import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type { MasterResponse } from '../models/master.model';
import { createCachedObservable } from '../utils/cached-observable.util';

/**
 * Caché en memoria del master: una sola petición GET /api/master por ciclo de vida de la app
 * (salvo que se llame a {@link MasterService.clearCache}, p. ej. tras logout).
 *
 * Cualquier llamada a {@link MasterService.getMaster} devuelve el mismo observable compartido;
 * la primera suscripción dispara la petición; el resto recibe el valor ya emitido sin repetir HTTP.
 */
@Injectable({ providedIn: 'root' })
export class MasterService {
  private readonly baseUrl = `${environment.apiUrl}/api`;

  private readonly masterCache = createCachedObservable(() =>
    this.http.get<MasterResponse>(`${this.baseUrl}/master`),
  );

  constructor(private http: HttpClient) {}

  getMaster(): Observable<MasterResponse> {
    return this.masterCache.get();
  }

  /** Invalida la caché; la siguiente `getMaster()` volverá a llamar al API. */
  clearCache(): void {
    this.masterCache.clear();
  }
}
